<template>
  <div class="container-fluid">
    <section v-show="efitment.eObjectType !== 'NotReady'">
      <div class="row">
        <div class="col-12">
          <div class="card card-form">
            <div class="card-header">
              <div class="row">
                <div class="col">
                  <div class="pull-left">
                    <h4 class="card-title float-left" v-if="efitment.id">
                      {{ $t("fitment.label") }}</h4>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col d-flex gap-3">

                  <button class="all-btn btn-outline-success"
                          v-if="efitment.eObjectType === 'Waiting'"
                          @click="bindToComplement()">
                    <i class="fa fa-check me-1"></i>
                    {{ $t("realEstate.action.bindComplement") }}
                  </button>

                  <button class="all-btn delete-btn ml-2"
                          v-if="efitment.eObjectType === 'Waiting'"
                          @click="showReject">
                    <i class="fa fa-reply"></i>
                    {{ $t("realEstate.action.pending") }}
                  </button>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <div class="section-header">
                    <h4>Бахолаш учун тақдим қилинган хужжатлар</h4>
                  </div>
                </div>
                <template>
                  <PreviewDropZone
                      code="documentsDropZone"
                      label="Мурожат хати ёки Паспорт нусхаси"
                      :data="efitment.letterFiles"
                      @change="(files) => {efitment.letterFiles = files}"
                  />

                  <template v-if="isOwnerTypeLegal && isOrgTypeMib">
                    <PreviewDropZone
                        code="actOfSaleDropZone"
                        label="realEstate.field.docActOfSale"
                        :data="efitment.actOfSaleFiles"
                        @change="(files) => {efitment.actOfSaleFiles = files}"
                    />
                    <PreviewDropZone
                        code="decisionDropZone"
                        label="realEstate.field.docDecision"
                        :data="efitment.decisionFiles"
                        @change="(files) => {efitment.decisionFiles = files}"
                    />
                    <PreviewDropZone
                        code="playlistDropZone"
                        label="realEstate.field.docPlaylist"
                        :data="efitment.executivePlaylistFiles"
                        @change="(files) => {efitment.executivePlaylistFiles = files}"
                    />
                  </template>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template>
        <b-modal v-model="show" title="Асосий воситани бекор қилиш">
          <div class="container-fluid">
            <div class="form-group">
              <label>Бекор қилиш сабабини киритинг<span class="red">*</span></label>
              <textarea class="form-control"
                        v-model="efitment.reasonDesc">
                        </textarea>
            </div>
          </div>
          <div slot="modal-footer">
            <button
                type="button"
                class="all-btn add-btn float-right ml-2"
                @click="rejectAppraisal()"
            >{{ $t("action.save") }}
            </button>
            <button
                type="button"
                class="all-btn delete-btn float-right"
                @click="rejectModalHide"
            >{{ $t("action.cancel") }}
            </button>
          </div>
        </b-modal>
      </template>
    </section>
  </div>
</template>

<script>

import PreviewDropZoneEAppraisal from "@/views/real-estate/PreviewDropZoneEAppraisal";
import PreviewDropZone from '@/views/real-estate/PreviewDropZone'
import bModal from 'bootstrap-vue/es/components/modal/modal'
import initFilterModel from '@/shared/filter';
import {requiredUnless} from 'vuelidate/lib/validators';

export default {
  name: "EFitmentView",
  components: {
    PreviewDropZone,
    PreviewDropZoneEAppraisal,
    'b-modal': bModal
  },
  data() {
    return {
      processing: false,
      show: false,
      efitment: {
        reasonDesc: '',
        evlContractAmount: 0
      },
      filter: initFilterModel(),
      agents: [],
      createUser: {}
    }
  },
  validations() {
    return {
      createUser: {
        required: requiredUnless(() => {
          return !(this.efitment.eObjectType === 'NotReady');
        })
      }
    }
  },
  methods: {
    init() {
      const vm = this;
      const id = this.$route.params.id;
      if (id && id > 0) {
        this.$http.get('/e-appraisal/fitment/' + id)
            .then(res => {
              vm.efitment = res.data;
              vm.createUser = {
                id: res.createUserId
              };
              this.processing = false;
            }, () => {
              this.$swal({
                title: this.$t('messages.common.error'),
                text: this.$t('messages.fixedExpense.error'),
                type: 'error'
              });
              this.processing = false;
            })

      }
    },
    rejectAppraisal() {
      if (this.efitment.reasonDesc) {
        this.processing = true;
        const data = {
          rejectObjectId: this.efitment.id,
          comment: this.efitment.reasonDesc
        };
        this.$http.post('e-appraisal/fitment/status/reject', data)
            .then(res => {
              if (res && res.data && res.data.status === 'SUCCESS') {
                this.$router.push('/e-appraisal/fitment/list');
              } else {
                this.$swal({
                  title: this.$t('messages.common.warning'),
                  text: this.$t('asset.statusWarning'),
                  type: 'warning'
                });
              }
              this.processing = false;
            }, () => {
              this.$swal({
                title: this.$t('messages.common.error'),
                text: this.$t('asset.statusError'),
                type: 'error'
              });
              this.processing = false;
            })
      } else {
        this.$swal({
          title: 'Хабар!',
          text: 'Бекор қилиш сабабини киритинг!',
          type: 'warning'
        });
      }
    },
    showReject() {
      this.efitment.reasonDesc = '';
      this.show = true;
    },
    rejectModalHide() {
      this.show = false;
    },
    bindToComplement() {
      const vm = this;
      vm.processing = true;
      this.$http.get('e-appraisal/fitment/bind-complement/' + vm.efitment.id)
          .then(res => {
            if (res && res.data && res.data.body && res.data.body.status === 'SUCCESS') {
              this.$router.push('/e-appraisal/fitment/list');
            } else {
              this.$swal({
                title: this.$t('messages.common.warning'),
                text: this.$t(res.data.message),
                type: 'warning'
              });
            }
            vm.processing = false;
          }, () => {
            this.$swal({
              title: this.$t('messages.common.error'),
              text: this.$t('messages.common.errorOccurred'),
              type: 'error'
            });
            vm.processing = false;
          })
    }
  },
  created() {
    this.filter.province = null;
    this.init();
  },
  computed: {
    isOwnerTypeLegal() {
      return !!(this.efitment.ownerClient && this.efitment.ownerClient.type && this.efitment.ownerClient.type === 'Legal');
    },
    isOrgTypeMib() {
      return !!(this.efitment.ownerClient && this.efitment.ownerClient.organizationType &&
          (this.efitment.ownerClient.organizationType === 'BUREAU_OF_COMPULSORY_EXECUTION' || this.efitment.ownerClient.organizationType === 'CUSTOMS_ADMINISTRATION'));
    }
  }
}
</script>

<style scoped>

</style>